import { render, staticRenderFns } from "./AudienceList.vue?vue&type=template&id=6356acfb&scoped=true&"
import script from "./AudienceList.vue?vue&type=script&lang=ts&"
export * from "./AudienceList.vue?vue&type=script&lang=ts&"
import style0 from "./AudienceList.vue?vue&type=style&index=0&id=6356acfb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356acfb",
  null
  
)

export default component.exports